const parseDigits = value => (value ? value.replace(/\D+/g, '') : '');

export default parseDigits;
